
import { LicenseInfo } from '@mui/x-license-pro';

if (!process.env.REACT_APP_MUI_LICENSE_KEY && process.env.NODE_ENV === "development")
  console.warn("No license key found. Add REACT_APP_MUI_LICENSE_KEY to env.local if you are running locally");
  
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);   